import { useEffect } from 'react';
import { toast } from 'sonner';
import { useCall } from '../../contexts/CallContext';
import { useGroupCall } from '../../contexts/GroupCallContext';
import { createConversation } from '../../api/chat';

/**
 * 1:1 → group escalation. CallProvider wraps GroupCallProvider, so CallScreen
 * (rendered by CallProvider) cannot reach useGroupCall directly. This bridge
 * lives INSIDE GroupCallProvider and registers the escalation with CallContext.
 */
export default function CallEscalationBridge() {
  const { bindEscalate, hangup } = useCall();
  const { startGroupCall } = useGroupCall();

  useEffect(() => {
    bindEscalate(async ({ peerUserId, peerName, newUserIds }) => {
      try {
        const groupName = peerName ? `${peerName} +${newUserIds.length}` : 'Group call';
        const conv = await createConversation({
          type: 'call',
          name: groupName,
          member_ids: [peerUserId, ...newUserIds],
        });
        hangup();                       // end the 1:1 (logs its outcome + call_event)
        await startGroupCall(conv.id);  // re-ring peer + new people as a group
      } catch {
        toast.error('Could not add participant');
      }
    });
  }, [bindEscalate, hangup, startGroupCall]);

  return null;
}
